










import { Component, Prop, Vue } from 'vue-property-decorator';
import LottieAnimation from 'lottie-web-vue';

@Component({
  components: {
    LottieAnimation,
  },
})
export default class TaftImageAnimated extends Vue {
  @Prop({ type: String, default: 'lottie_loading' })
    fileName!: string;
  @Prop({ type: String, default: '120px' })
    height!: string;
}
